import { render, staticRenderFns } from "./Yampi.vue?vue&type=template&id=4fdb7bc5&"
import script from "./Yampi.vue?vue&type=script&lang=js&"
export * from "./Yampi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports